module.exports = __webpack_public_path__ + "img/flipkart.3e289763.svg";